import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFlag = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#000" fillRule="evenodd" d="M1 16h1.5v-6H7l2 2h6V3H9L7 1H1zM2.5 2.5v6h5.121l2 2H13.5v-6H8.379l-2-2z" clipRule="evenodd" />
  </svg>
);
export default SvgFlag;
